module.exports = __webpack_public_path__ + "static/media/M4V.a1066fc0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/M4V.svg
// module id = 1683
// module chunks = 17